export default __webpack_public_path__ + "static/media/three-dots.7200946d.svg";